import loadable from '@loadable/component';

export const RecommendationListLoadable = loadable(
  () => import('./RecommendationsList').catch(/* istanbul ignore next */ () => ({ RecommendationsList: () => null })),
  {
    resolveComponent: ({ RecommendationsList }) => RecommendationsList,
    ssr: false,
  },
);
